/**
 * Очистка локальных данных незавершённого заказа (корзина, креатив, название
 * кампании, расписание, orderId). Нужна при выходе, чтобы черновик одного
 * пользователя не «протекал» к следующему: после создания заказа работаем
 * только с серверным заказом, локальные данные не храним.
 *
 * Точек выхода из кабинета рекламодателя две — шапка и профиль, — поэтому
 * список ключей лежит здесь, а не рядом с одной из них.
 */

const ORDER_KEYS = [
  "basket",
  "basketOwner",
  "post",
  "campaignName",
  "orderId",
  "basketType",
  "scheduleId",
  "scheduleIds",
  "multiScheduleState",
  "orderScheduleStateV2",
  "draftId",
  "isDraft",
  "creativeId",
  "creativeUuid",
  "creativeTemporaryToken",
  "creativeFiles",
];

export const clearOrderLocalStorage = () => {
  if (!import.meta.client) return;

  ORDER_KEYS.forEach((key) => localStorage.removeItem(key));

  // Кэш договоров/оферт шага «Оплата» (привязан к пользователю)
  Object.keys(localStorage)
    .filter((key) => key.startsWith("ordDocsCache:"))
    .forEach((key) => localStorage.removeItem(key));
};
